import { connect } from "react-redux";
import { IntlProvider } from "react-intl";

const intl = context => {
  const { intl } = context;
  const intlRef = Object.assign({}, intl);

  intl.formatMessage = (config, state) => {
    if (config && config.id) {
      return intlRef.formatMessage(config, state);
    }

    return config && config.defaultMessage ? config.defaultMessage : "";
  };

  return context;
};

class ReduxIntlProvider extends IntlProvider {
  getChildContext() {
    const superContext = super.getChildContext();

    return intl(superContext);
  }
}

const mapStateToProps = ({ intl }) => ({
  key: intl.locale,
  ...intl,
});

export default connect(mapStateToProps)(ReduxIntlProvider);



// WEBPACK FOOTER //
// ./i18n/ReduxIntlProvider.js